import { render, staticRenderFns } from "./PayrollTypeTimeSummary.vue?vue&type=template&id=680c1b45"
import script from "./PayrollTypeTimeSummary.vue?vue&type=script&lang=js"
export * from "./PayrollTypeTimeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports